/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import {
    Box,
    Button,
    FlexCol,
    FlexRow,
    Icon,
    RequiredValidation,
    Select,
    SelectOption,
    TextField,
} from 'sarsaparilla';

import { licensePlateValidator } from '../utils/format';
import VehicleStatePicker from './VehicleStatePicker';

// import type { OnChangeEventType } from '../types';

function VehicleItem(
    {
        index,
        isMakeRequired = false,
        isMakeInvalid = false,
        isLicensePlateRequired = false,
        isLicensePlateInvalid = false,
        isReadOnly = false,
        isTypeRequired = false,
        isTypeInvalid = false,
        isStateRequired = false,
        licensePlate,
        make,
        onLicensePlateValidated,
        onLicensePlateChanged,
        onMakeValidated,
        onMakeChanged,
        onRemoveVehicle,
        onStateChanged,
        onTypeChanged,
        onTypeValidated,
        state,
        type,
        typesOptions,
    }
    // : {
    // index: number,
    // isMakeRequired?: boolean,
    // isMakeInvalid?: boolean,
    // isLicensePlateRequired?: boolean,
    // isLicensePlateInvalid?: boolean,
    // isReadOnly?: boolean,
    // isTypeRequired?: boolean,
    // isTypeInvalid?: boolean,
    // isStateRequired?: boolean,
    // licensePlate: string,
    // make: string,
    // onLicensePlateValidated: (boolean, string, number) => void,
    // onLicensePlateChanged: (number, string) => void,
    // onMakeValidated: (boolean, string, number) => void,
    // onMakeChanged: (number, string) => void,
    // onRemoveVehicle: (number) => void,
    // onStateChanged: (number, string) => void,
    // onTypeChanged: (number, string) => void,
    // onTypeValidated: (boolean, string, number) => void,
    // state: string,
    // type?: string,
    // typesOptions?: string[],
    // }
) {
    return (
        <Box>
            <FlexRow alignItems="start">
                {typesOptions?.length && (
                    <FlexCol sm={6} xl={3}>
                        <Select
                            id={`vehicle${index}-type`}
                            isDisabled={isReadOnly}
                            isRequired={isTypeRequired}
                            isInvalid={isTypeInvalid}
                            label="Vehicle Type"
                            placeholder="Choose an option"
                            value={type}
                            onChange={(e) => onTypeChanged(index, e?.target?.value)}
                        >
                            {typesOptions?.map((option) => (
                                <SelectOption key={option} value={option}>
                                    {option}
                                </SelectOption>
                            ))}
                        </Select>
                        {isTypeRequired && (
                            <RequiredValidation
                                value={type}
                                displayInSummary
                                onValidated={(isInValid, error) =>
                                    onTypeValidated(isInValid, error, index)
                                }
                                controlLabel={`Vehicle #${index + 1} Type`}
                            />
                        )}
                    </FlexCol>
                )}

                <FlexCol sm={6} xl={3}>
                    <TextField
                        id={`vehicle${index}-make`}
                        isDisabled={isReadOnly}
                        isRequired={isMakeRequired}
                        isInvalid={isMakeInvalid}
                        onChange={(e) => onMakeChanged(index, e?.target?.value)}
                        value={make}
                        label="Description (Make/Model)"
                    />
                    {isMakeRequired && (
                        <RequiredValidation
                            value={make}
                            displayInSummary
                            onValidated={(isInValid, error) =>
                                onMakeValidated(isInValid, error, index)
                            }
                            controlLabel={`Vehicle #${index + 1} Make`}
                        />
                    )}
                </FlexCol>

                <FlexCol sm={6} xl={3}>
                    <TextField
                        id={`vehicle${index}-license-plate`}
                        isDisabled={isReadOnly}
                        isRequired={isLicensePlateRequired}
                        isInvalid={isLicensePlateInvalid}
                        onChange={(e) => onLicensePlateChanged(index, e?.target?.value)}
                        value={licensePlate}
                        label="License Plate #"
                        validator={licensePlateValidator}
                        shouldReformatValue
                    />
                    {isLicensePlateRequired && (
                        <RequiredValidation
                            value={licensePlate}
                            displayInSummary
                            onValidated={(isInValid, error) =>
                                onLicensePlateValidated(isInValid, error, index)
                            }
                            controlLabel={`Vehicle #${index + 1} License Plate`}
                        />
                    )}
                </FlexCol>
                <FlexCol sm={6} xl={3}>
                    <VehicleStatePicker
                        id={`vehicle${index}-state-picker`}
                        isDisabled={isReadOnly}
                        isRequired={isStateRequired}
                        onChange={(e) => onStateChanged(index, e?.target?.value)}
                        value={state}
                        label="State"
                    />
                </FlexCol>
                <FlexCol sm={6} xl={3} alignSelf="end">
                    <div className="per-form-group-item-remove">
                        <Button
                            appearance="subtle-danger"
                            onClick={() => onRemoveVehicle(index)}
                            iconBeforeElement={<Icon iconName="delete" />}
                            screenReaderTextBefore={`Remove row ${index + 1} from the vehicle list`}
                        >
                            Delete
                        </Button>
                    </div>
                </FlexCol>
            </FlexRow>
        </Box>
    );
}

export default VehicleItem;
